import { render, staticRenderFns } from "./test.vue?vue&type=template&id=3ed4d79e&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4d79e",
  null
  
)

export default component.exports